export default {"src":"/_next/static/media/define.1cb22113.svg","height":76,"width":158,"blurWidth":0,"blurHeight":0};